var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.appBarHeightStyle)},[_c('a',{staticClass:"skip-link",attrs:{"href":"#main-content"}},[_vm._v("メインコンテンツへ移動")]),_c('AppHeader',{attrs:{"app-bar-height":_vm.appBarHeight}}),_c('v-main',{ref:"mainContent",attrs:{"id":"main-content","tabindex":"-1"}},[_c('router-view')],1),_c('BackToTop'),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }